import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { updateActionsErrors } from 'redux/smartchat/details/actions'
import { setAlternativesActionsErrors } from 'redux/smartchat/alternatives/actions'
import FieldTextNumberViewUI from './FieldTextNumberViewUI'

const FieldTextNumberView = ({ renderType, label, placeholder, optionsData, actionType, dataWay, currentValue, onChange, error }) => {
  const { modalActionRef } = useSelector(store => ({
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const dispatch = useDispatch()
  const [value, setValue] = useState('')
  const [dataToExport, setDataToExport] = useState(currentValue || {})
  const [previewIntegrity, setPreviewIntegrity] = useState(null)


  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (renderType === 'action') {
        if (modalActionRef.mode !== 'update') return
        onChange(currentValue)
      }

      let updatedPreviewIntegrity = previewIntegrity

      // TextBox
      const value = currentValue[optionsData.fieldName]

      if (value) {
        if (updatedPreviewIntegrity) updatedPreviewIntegrity = null
        setValue(value)
      } else {
        // Error report
        if (renderType === 'action') {
          dataWay?.type === 'alternatives'
            ? dispatch(setAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: { [actionType]: I18n.t('smartchat_tooltip_warning_notFound') } }))
            : dispatch(updateActionsErrors({ [actionType]: I18n.t('smartchat_tooltip_warning_notFound') }))
        } else {
          updatedPreviewIntegrity = I18n.t('smartchat_tooltip_warning_notFound')
        }
      }

      // Error report
      if (renderType === 'preview') setPreviewIntegrity(updatedPreviewIntegrity)
    }

    return () => isSubscribed = false
  }, [currentValue])

  const onChangeInner = (textValue) => {
    const updatedDataToExport = { ...dataToExport }

    // Data to export
    if (textValue) {
      updatedDataToExport[optionsData.fieldName] = textValue
    } else {
      updatedDataToExport[optionsData.fieldName] = ''
    }

    // Update local data
    setValue(textValue)
    setDataToExport(updatedDataToExport)

    // Export the data
    onChange(updatedDataToExport)
  }

  return (
    <FieldTextNumberViewUI
      renderType={renderType}
      label={label}
      placeholder={placeholder}
      value={value}
      onChangeInner={onChangeInner}
      error={error}
      fieldName={optionsData.fieldName}
    />
  )
}

export default FieldTextNumberView